import Template from './DashboardHeader.njk';
import Marionette from "backbone.marionette";
import { ClockView } from "./Clock";
import { Config } from "../../application/Config";
import "./DashboardHeader.less";

/**
 * @param Seller model
 */
export const DashboardHeaderView = Marionette.View.extend({
  template: Template,
    className: "DashboardHeader",
    modelEvents: {
        'change': 'render'
    },

    regions: {
        time: '.time'
    },

    initialize(options) {
        this.settings = options.settings;
    },

    templateContext() {
        var title = this.model.get("name");
        var settings = this.settings;

        if (settings.header.title !== null) {
            title = settings.header.title;
        }

        return {
            title: title,
            settings: settings,
            logoUrl: Config.baseUrl.configuration + "/" + settings.header.logoImage
        }
    },

    onRender() {
        this.showChildView("time", new ClockView());
    }
});



// WEBPACK FOOTER //
// ./src/js/view/components/DashboardHeader.js